// internal
import { axios, def, storage, handleResponse, handleError } from './internal';

// storage
import { getFilterRecord, updateFilterRecord } from '../storage/indexeddb';

function putInMemory(option) {
    const exists = storage.transience.getValue('filter.option.data').some((x) => x._id === option._id);
    if (exists) storage.transience.updateState('filter.option.data', (x) => x._id === option._id, option);
    else storage.transience.addState('filter.option.data', option);
}

// Downloads one option body and stores it in its entry of the `group` list's record (`filterOptions.data`).
// The entries themselves come from the filter list response, see saveFilterList.
async function FilterGetOption(filterOptionId, onSuccess, setData, group) {
    setData?.((prev) => ({ ...prev, loading: true }));

    const record = group ? await getFilterRecord(group) : null;
    const entries = record?.filterOptions.data ?? [];
    const entry = entries.find((e) => e._id === filterOptionId);
    const filterOptionHash = entry?.data ? entry.hash : '';
    // Changes the entries of the record as it is when this write runs (other downloads may have finished meanwhile).
    // A record without filters is never written; the list response creates it. The options' meta stays as is:
    // filling a body does not change the list of options.
    const saveEntries = (change) =>
        updateFilterRecord(group, (rec) =>
            rec.filters.data
                ? { ...rec, filterOptions: { ...rec.filterOptions, data: change(rec.filterOptions.data) } }
                : null,
        );

    axios
        .get(`/api/filter-options/${encodeURIComponent(filterOptionId)}`, { params: { filterOptionHash }, guest: true })
        .then(async (res) => {
            switch (res.data.code) {
                case def.ErrorCode.OK: {
                    const { filterOption, meta } = res.data.data;
                    // meta null = the option no longer exists / is INACTIVE: no choices, and drop it from the record.
                    if (meta === null) {
                        if (group) await saveEntries((list) => list.filter((e) => e._id !== filterOptionId));
                        storage.transience.removeState(
                            'filter.option.data',
                            (x) => String(x._id) === String(filterOptionId),
                        );
                        onSuccess?.({ options: [] });
                        break;
                    }
                    const option = filterOption ?? entry?.data ?? null;
                    if (option) {
                        if (filterOption !== null) {
                            const filled = { _id: filterOptionId, hash: meta.hash, data: option };
                            if (group) {
                                await saveEntries((list) =>
                                    list.some((e) => e._id === filterOptionId)
                                        ? list.map((e) => (e._id === filterOptionId ? filled : e))
                                        : [...list, filled],
                                );
                            }
                        }
                        putInMemory(option);
                        onSuccess?.(option);
                    }
                    break;
                }
                default:
                    handleResponse(res);
                    break;
            }
        })
        .catch((err) => {
            handleError(err);
        })
        .finally(() => setData?.((prev) => ({ ...prev, loading: false })));
}

export { FilterGetOption };
